module.exports = __webpack_public_path__ + "static/media/connect.704a6b4a.svg";